export default __webpack_public_path__ + "static/about-9f4aa42e1e0ac8ccccef49a2a521334d.png";